import * as React from 'react';
import { post } from '../../webapi';
import { Subject, TagHolderTypes } from '../../Model/core';
import { Tag } from './Tag';
import { getQueryStringValue } from '../../util';
import { tagEventHandler } from '../../Event/Handlers';


export interface TagListState {
    subjects: Subject[];
    selectedTitle?: string;
    showAll: boolean;
}

export interface TagListProps {
    tagType: TagHolderTypes;
    showAllTags?: string;
}

export class TagList extends React.Component<TagListProps, TagListState> {
    constructor(props: TagListProps) {
        super(props);
        this.state = {
            subjects: [],
            selectedTitle: getQueryStringValue('subject'),
            showAll: false
        };
        this.onChange = this.onChange.bind(this);
        this.toggleShowAll = this.toggleShowAll.bind(this);
        this.loadArticlesOnGoBack = this.loadArticlesOnGoBack.bind(this);
    }
    
    componentDidMount() {
        window.addEventListener('popstate', this.loadArticlesOnGoBack);
        this.fetchSubjects();
    }

    async fetchSubjects() {
        const { tagType } = this.props;
        const subjects = await post<Subject[]>('/blApi/GetAllSubjects', { TagType: tagType });
        this.setState({
            subjects
        });
    }

    loadArticlesOnGoBack() {
        const queryValue = getQueryStringValue('subject');

        const { subjects } = this.state;
        const subject = subjects.find(x => x.Title === queryValue);
        tagEventHandler.fire(subject);

        if (!subject) {
            this.setState({
                selectedTitle: ""
            });
            return;
        }
        
        this.setState({ 
            selectedTitle: subject.Title
        });
    }

    toggleShowAll(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        const { showAll } = this.state;
        this.setState({ showAll: !showAll });
    }

    onChange(selectedTitle?: string) {
        this.setState({ selectedTitle });
    }

    render() {
        const { subjects, selectedTitle, showAll } = this.state;
        const filterText = showAll ? 'Visa färre' : 'Visa fler ämnen';
        const iconClass = showAll ? 'white-chevron-up' : 'white-chevron-down';
        const cls = showAll ? ' shown' : ' collapsed';
        
        return (
            <div className="row pb-5">
                {this.props.showAllTags == "True" ? (
                    <div className="col-12">
                        <div className="tags">
                            {subjects.map((subject) =>
                                <Tag
                                    key={subject.PageId}
                                    subject={subject}
                                    onChange={this.onChange}
                                    selectedTitle={selectedTitle}
                                />
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="col-12">
                        <div className="tags">
                            {subjects.filter(subject => subject.IsMain).map((subject) =>
                                <Tag
                                    key={subject.PageId}
                                    subject={subject}
                                    onChange={this.onChange}
                                    selectedTitle={selectedTitle}
                                />
                            )}
                        </div>
                        <div className={'tags' + cls}>
                            {subjects.filter(subject => !subject.IsMain).map((subject) =>

                                <Tag
                                    key={subject.PageId}
                                    subject={subject}
                                    onChange={this.onChange}
                                    selectedTitle={selectedTitle}
                                />
                            )}
                        </div>
                        <div className="tags-filter" style={{ display: !showAll ? 'block' : 'none' }}>
                            <a href="#" onClick={this.toggleShowAll}>
                                <span>{filterText}</span>
                                <div className={iconClass + ' chevron-icon'}></div>
                            </a>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}